import { UserCard } from '@/modules/users/components/UserCard';
import type { UserApi } from '@/modules/users/types';

interface UserListProps {
  users: UserApi[];
}

export const UserList = ({ users }: UserListProps) => {
  return (
    <div className="flex flex-col gap-4">
      {users.map((user) => (
        <UserCard key={user.id} user={user} />
      ))}
    </div>
  );
};
